import { Skeleton, SkeletonRegion } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface Props {
  lines?: number;
  className?: string;
}

/** Standard page card (title bar + body lines) shell used by feature pages. */
export default function CardSkeleton({ lines = 3, className }: Props) {
  return (
    <SkeletonRegion
      className={cn(
        "rounded-[14px] border border-border bg-card p-4 shadow-card sm:p-5 space-y-3",
        className,
      )}
    >
      <Skeleton className="h-4 w-1/3" />
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton
          key={i}
          className={i === lines - 1 ? "h-3.5 w-2/3" : "h-3.5 w-full"}
        />
      ))}
    </SkeletonRegion>
  );
}
